{
  "route": "stellar",
  "railEntries": [
    {
      "label": "Proposition",
      "anchor": "stellar-section-1"
    },
    {
      "label": "Lexicon",
      "anchor": "stellar-section-2"
    },
    {
      "label": "Recognition",
      "anchor": "stellar-section-3"
    },
    {
      "label": "Gift & limit",
      "anchor": "stellar-section-4"
    }
  ],
  "anchors": [
    "stellar-section-1",
    "stellar-section-2",
    "stellar-section-3",
    "stellar-section-4"
  ],
  "nodes": [
    {
      "tag": "section",
      "attrs": {
        "class": "route chapter stellar-chapter",
        "id": "route-stellar",
        "aria-labelledby": "stellar-title"
      },
      "children": [
        {
          "tag": "div",
          "attrs": {
            "class": "wrap"
          },
          "children": [
            {
              "tag": "header",
              "attrs": {
                "class": "chapter-hero"
              },
              "children": [
                {
                  "tag": "div",
                  "children": [
                    {
                      "tag": "span",
                      "attrs": {
                        "class": "chapter-index"
                      },
                      "children": [
                        "01 · The Sunrise"
                      ]
                    },
                    " ",
                    {
                      "tag": "h1",
                      "attrs": {
                        "id": "stellar-title"
                      },
                      "children": [
                        "Stellar & ",
                        {
                          "tag": "em",
                          "children": [
                            "the threshold."
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "chapter-deck"
                      },
                      "children": [
                        "A theory of civilisational phase change: the old extractive order is reaching its limit while converging technologies make a radically different organising system possible."
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "aside",
                  "attrs": {
                    "class": "chapter-aside"
                  },
                  "children": [
                    {
                      "tag": "strong",
                      "children": [
                        "Source posture"
                      ]
                    },
                    "Faithful synthesis of the supplied Stellar recognition artifact, cross-checked against Stellar’s official public thesis. Its forecasts remain propositions, not settled facts. ",
                    {
                      "tag": "a",
                      "attrs": {
                        "class": "source-link",
                        "href": "https://www.rethinkx.com/publications/stellar",
                        "target": "_blank",
                        "rel": "noreferrer"
                      },
                      "children": [
                        "[S01]"
                      ]
                    }
                  ]
                },
                " "
              ]
            },
            " ",
            {
              "tag": "div",
              "attrs": {
                "class": "chapter-body"
              },
              "children": [
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "stellar-section-1"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "The proposition"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "The problem is not a broken machine. It is an ",
                            {
                              "tag": "em",
                              "children": [
                                "obsolete organising system."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "lead"
                      },
                      "children": [
                        "Stellar argues that twelve millennia of extraction, scarcity and hierarchy are colliding with technologies whose cost curves could make energy, intelligence, transport and food radically more abundant. The danger is the ",
                        {
                          "tag": "strong",
                          "children": [
                            "Chimera"
                          ]
                        },
                        ": new capability captured by old logic."
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "panel-grid three"
                      },
                      "children": [
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel accent"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label proposition"
                              },
                              "children": [
                                "Author proposition"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "The sunset"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "The inherited system is producing exactly what it was designed to produce: concentrated power, extraction and brittle dependence."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel accent"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label proposition"
                              },
                              "children": [
                                "Author proposition"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "The ignition"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Solar, wind, batteries, AI, robotics and precision fermentation converge into a non-linear technological phase change."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel accent"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label proposition"
                              },
                              "children": [
                                "Author proposition"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "The nursery"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "The new order must be grown beside the old and protected long enough to develop its own culture, institutions and logic."
                              ]
                            }
                          ]
                        },
                        " "
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "stellar-section-2"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "Working lexicon"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "Six ideas that gave you ",
                            {
                              "tag": "em",
                              "children": [
                                "recognition language."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "lexicon-grid"
                      },
                      "children": [
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "lexicon-item"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "children": [
                                "01"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Organising system"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "The deep rules of ownership, power, incentives and meaning that shape what a society repeatedly produces."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "lexicon-item"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "children": [
                                "02"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Phase change"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "A shift in kind, not degree: the moment accumulated pressure becomes a new system state."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "lexicon-item"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "children": [
                                "03"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Chimera"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "New tools grafted onto extraction, intensifying the old order rather than replacing it."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "lexicon-item"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "children": [
                                "04"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Stellar nursery"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "A protected, parallel space where the sunrise system can learn before it must survive at full scale."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "lexicon-item"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "children": [
                                "05"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Radiance"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "A generative orientation: value expands through participation rather than depletion."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "lexicon-item"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "children": [
                                "06"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Doubling down"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "The old system’s reflex to answer instability with more of the logic that created it."
                              ]
                            }
                          ]
                        },
                        " "
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "stellar-section-3"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "The recognition"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "Stellar did not invent your model. It ",
                            {
                              "tag": "em",
                              "children": [
                                "revealed its scale."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "table",
                      "attrs": {
                        "class": "comparison"
                      },
                      "children": [
                        {
                          "tag": "thead",
                          "children": [
                            {
                              "tag": "tr",
                              "children": [
                                {
                                  "tag": "th",
                                  "children": [
                                    "Stellar language"
                                  ]
                                },
                                {
                                  "tag": "th",
                                  "children": [
                                    "Your lived pattern"
                                  ]
                                },
                                {
                                  "tag": "th",
                                  "children": [
                                    "Recognition"
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "tbody",
                          "children": [
                            {
                              "tag": "tr",
                              "children": [
                                {
                                  "tag": "td",
                                  "children": [
                                    "Phase change"
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Interventions hold only when a system reaches readiness."
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "The Threshold is a practical theory of non-linear change."
                                  ]
                                }
                              ]
                            },
                            " ",
                            {
                              "tag": "tr",
                              "children": [
                                {
                                  "tag": "td",
                                  "children": [
                                    "Nursery"
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "You compose a protected room around a real case."
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "The room is where new institutional behaviour can be rehearsed."
                                  ]
                                }
                              ]
                            },
                            " ",
                            {
                              "tag": "tr",
                              "children": [
                                {
                                  "tag": "td",
                                  "children": [
                                    "Chimera"
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Premature help spikes, gets absorbed and fades."
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Timing is not etiquette; it determines whether change is captured."
                                  ]
                                }
                              ]
                            },
                            " ",
                            {
                              "tag": "tr",
                              "children": [
                                {
                                  "tag": "td",
                                  "children": [
                                    "Sunset / sunrise"
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "You have spent a career between systems, sectors and mandates."
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Your role is not to own the future, but to broker the handover."
                                  ]
                                }
                              ]
                            },
                            " "
                          ]
                        },
                        " "
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "quote-panel"
                      },
                      "children": [
                        {
                          "tag": "blockquote",
                          "children": [
                            "“Read the readiness. Compose the room. ",
                            {
                              "tag": "em",
                              "children": [
                                "Let the system cross."
                              ]
                            },
                            "”"
                          ]
                        },
                        {
                          "tag": "cite",
                          "children": [
                            "Nicole’s Threshold spine · supplied Earth 2.0 declaration"
                          ]
                        }
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "stellar-section-4"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "What it gives / misses"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "A powerful destination. An incomplete ",
                            {
                              "tag": "em",
                              "children": [
                                "politics of arrival."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "panel-grid"
                      },
                      "children": [
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel accent"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label synthesis"
                              },
                              "children": [
                                "Synthesis"
                              ]
                            },
                            {
                              "tag": "h2",
                              "children": [
                                "Its gift"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Stellar expands the possible. It names capture, legitimises parallel institution-building and gives you language for the moment between sunset and sunrise."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel accent"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label synthesis"
                              },
                              "children": [
                                "Pressure test"
                              ]
                            },
                            {
                              "tag": "h2",
                              "children": [
                                "Its limit"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Technology cost curves do not settle ownership, sovereignty, ecological limits, material throughput, justice or democratic legitimacy. Abundance can be captured. Power must be designed, not wished away."
                              ]
                            }
                          ]
                        },
                        " "
                      ]
                    },
                    " ",
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "footnote"
                      },
                      "children": [
                        "Earth 3.0 therefore treats Stellar’s abundance as a ",
                        {
                          "tag": "strong",
                          "children": [
                            "scenario to prepare for"
                          ]
                        },
                        ", not a promise on which the whole architecture depends."
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "button",
                  "attrs": {
                    "class": "route-next",
                    "type": "button",
                    "data-go": "earth2"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "children": [
                        "Next field"
                      ]
                    },
                    {
                      "tag": "span",
                      "children": [
                        "Earth 2.0 · The Crossing →"
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "footer",
                  "attrs": {
                    "class": "tiny-footer"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "children": [
                        "01 · Stellar"
                      ]
                    },
                    {
                      "tag": "span",
                      "children": [
                        "Possibility without governance is exposure"
                      ]
                    }
                  ]
                },
                " "
              ]
            },
            " "
          ]
        },
        " "
      ]
    },
    " "
  ]
}
